import { render, staticRenderFns } from "./Factura.vue?vue&type=template&id=025c152c&scoped=true&"
import script from "./Factura.vue?vue&type=script&lang=js&"
export * from "./Factura.vue?vue&type=script&lang=js&"
import style0 from "./Factura.vue?vue&type=style&index=0&id=025c152c&lang=scss&scoped=true&"
import style1 from "./Factura.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025c152c",
  null
  
)

export default component.exports